import { render, staticRenderFns } from "./Join.vue?vue&type=template&id=d2295c30&scoped=true&"
import script from "./Join.vue?vue&type=script&lang=js&"
export * from "./Join.vue?vue&type=script&lang=js&"
import style0 from "./Join.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Join.vue?vue&type=style&index=1&id=d2295c30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2295c30",
  null
  
)

export default component.exports